import { Component } from '@angular/core';
import { take } from 'rxjs/operators';

import { CHECKOUT_STEP, CheckoutFlowService } from '../../../../../../checkout/checkout-flow.service';
import { CheckoutService } from '../../../../../../checkout/checkout.service';
import { IInsuranceType } from '../../../checkout-step-insurance/checkout-step-insurance.component';

@Component({
    selector: 'app-insurance-summary',
    template: `
        <ng-container *ngIf="checkoutService.getCheckoutData() | async as cd">
            <section
                class="summary"
                [ngClass]="{ 'summary--active': true, 'summary--has-error': hasValidationError }"
                appCircleCheckmark
                [condition]="!hasValidationError"
                appCircleError
                [errorCondition]="hasValidationError"
            >
                <div class="summary__header">
                    <h3 class="h5 no-margin">
                        {{ 'checkout.summary_step____insurance_section____headline' | translate }}
                    </h3>
                    <app-button
                        (click)="checkoutflowService.goToStep(step)"
                        [buttonClass]="'button--minimal theme-text'"
                        [title]="(hasValidationError ? 'checkout.summary_step____button_currect_step' : 'buttons.edit') | translate"
                    >
                    </app-button>
                </div>
                <div class="summary__content text-small">
                    <div class="unstyled-table unstyled-table--first-child-bold" role="table">
                        <div class="unstyled-table__row" role="row">
                            <div class="unstyled-table__cell" role="cell">
                                {{ 'checkout.summary_step____insurance_section____choosen_company' | translate }}
                            </div>
                            <ng-container *ngIf="cd.insurance?.company === InsuranceTypes.nonSelected || cd.insurance?.company === null">
                                {{ 'checkout.summary_step____insurance_section____no_company_choosen' | translate }}
                            </ng-container>
                            <ng-container *ngIf="cd.insurance?.company && cd.insurance?.company !== InsuranceTypes.nonSelected">
                                <div class="unstyled-table__cell" role="cell">{{ cd.insurance?.company }}</div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </section>
        </ng-container>
    `,
})
export class InsuranceSummaryComponent {
    InsuranceTypes = IInsuranceType;
    hasValidationError?: boolean;
    step = CHECKOUT_STEP.CS_INSURANCE;
    constructor(public checkoutService: CheckoutService, public checkoutflowService: CheckoutFlowService) {
        this.checkoutService.purchaseOrderValidation$.pipe(take(2)).subscribe((data) => {
            if (data) {
                this.hasValidationError = !!data?.errors?.find((e) => e.property?.split('.')?.[0] === 'Insurance');
            }
        });
    }
}
